import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgAcneGlyphSecondary from './svgs/AcneGlyphSecondary.js';
import SvgAcneGlyph from './svgs/AcneGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var acneGlyph = (props => useIcon(SvgAcneGlyph, SvgAcneGlyphSecondary, props));

export { acneGlyph as default };
